import axios from "axios";
import { getBackendUrl } from "../../../utils/env";

// Normaliza la base para no depender de si getBackendUrl() termina en "/" o no
const baseUrl = () => getBackendUrl().replace(/\/+$/, "");
const productsUrl = () => `${baseUrl()}/api/admin/products.php`;

export const getImageUrl = (path) =>
  path ? `${baseUrl()}/${String(path).replace(/^\/+/, "")}` : undefined;

const assertSuccess = (data, errorMessage) => {
  if (!data?.success) throw new Error(errorMessage);
  return data;
};

export async function fetchProducts() {
  const { data } = await axios.get(productsUrl());
  return assertSuccess(data, "No se pudieron cargar los productos").products;
}

export async function fetchCategories() {
  const { data } = await axios.get(productsUrl(), {
    params: { categories: true },
  });
  assertSuccess(data, "No se pudieron cargar las categorías");
  return Array.isArray(data.categories) ? data.categories : [];
}

const buildProductFormData = (values, imageFile, variants) => {
  const formData = new FormData();
  const fields = {
    name: values.name,
    description: values.description,
    price: values.price,
    cash: values.cash || 0,
    category: values.category,
    // Para Ropa el backend recalcula stock/max_stock a partir de las variantes,
    // pero se envían por si el producto no es de Ropa.
    stock: values.stock,
    max_stock: values.max_stock,
    is_colective: values.is_colective ? 1 : 0,
  };
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null) formData.append(key, value);
  });
  if (imageFile) formData.append("image", imageFile);
  if (variants && variants.length > 0) {
    formData.append("variants", JSON.stringify(variants));
  }
  return formData;
};

export async function saveProduct({ values, imageFile, id, variants }) {
  const params = id ? { action: "update", id } : { action: "create" };
  const { data } = await axios.post(
    productsUrl(),
    buildProductFormData(values, imageFile, variants),
    { params }
  );
  return assertSuccess(data, "Error al guardar el producto");
}

export async function deleteProduct(id) {
  const { data } = await axios.delete(productsUrl(), {
    data: { id },
    headers: { "Content-Type": "application/json" },
  });
  return assertSuccess(data, "Error al eliminar producto");
}
